/// <amd-module name="VSS/Diagnostics/UI/Components/Section/Section" />
import * as React from "react";

import { PerfSectionDataSegment } from "VSS/Diagnostics/PerfBar";
import { Segment } from "VSS/Diagnostics/UI/Segment";
import { css } from "VSSUI/Util";

export interface ISectionProps {
    sectionLabel: string;
    dataSegments?: PerfSectionDataSegment[];
    onClick?: () => void;
}

export class Section extends React.Component<ISectionProps> {
    public render(): JSX.Element {
        let dataSegments: JSX.Element | undefined;
        if (this.props.dataSegments) {
            dataSegments = (
                <span className="perf-section-data flex-row flex-center">
                    {this.props.dataSegments.map<JSX.Element>((seg: PerfSectionDataSegment, index: number) => {
                        return <Segment key={index} dataSegment={seg} />;
                    })}
                </span>
            );
        }
        return (
            <span className={css("perf-section flex-row flex-center", !!this.props.onClick && "actionable")} onClick={this.props.onClick}>
                <span className="perf-section-label">{this.props.sectionLabel}</span>
                {dataSegments}
            </span>
        );
    }
}
